import * as Yup from 'yup'

const branchSchema = {}

branchSchema.validateBranchAdd = () => {
  return Yup.object({
    branch_name: Yup.string()
      .trim()
      .required('Branch name is required.')
      .min(2, 'Branch name minimum length is 2')
      .max(45, 'Branch name should be at most 10 characters.')
      .matches(/^[aA-z0-9Z-\s\@\$\#\&\_\.\(\)\[\]\,\:\'\-]+$/, `Branch name should be Alphanumeric only`),
    branch_address: Yup.string().nullable(),
   
    tally_godown: Yup.string()
      .trim()
      .min(3, 'Tally Godown minimum length is 3')
      .max(50, 'Tally Godown should be at most 50 characters.')
      .nullable(),
    voucher_type: Yup.string()
      .trim()
      .min(3, 'Voucher Type minimum length is 3')
      .max(50, 'Voucher Type should be at most 50 characters.')
      .nullable(),
    sales_ledger: Yup.string()
      .trim()
      .min(3, 'Sales Ledger minimum length is 3')
      .max(50, 'Sales Ledger should be at most 50 characters.')
      .nullable(),
        default_print_type: Yup.string().nullable(),
    expense_voucher_type: Yup.string()
      .trim()
      .max(45, "Expense Voucher Type should be at most 45 characters.")
      .nullable(),
    income_voucher_type: Yup.string()
      .trim()
      .max(45, "Income Voucher Type should be at most 45 characters.")
      .nullable(),
    cash_ledger: Yup.string()
      .trim()
      .max(45, "Cash Ledger should be at most 45 characters.")
      .nullable(),
    stock_voucher_type: Yup.string()
      .trim()
      .max(45, "Stock Voucher Type should be at most 45 characters.")
      .nullable(),
  })
}

branchSchema.validateBranchEdit = () => {
  return Yup.object({
    branch_name: Yup.string()
      .trim()
      .required('Branch name is required.')
      .min(2, 'Branch name minimum length is 2')
      .max(45, 'Branch name should be at most 10 characters.')
      .matches(/^[aA-z0-9Z-\s\@\$\#\&\_\.\(\)\[\]\,\:\'\-]+$/, `Branch name should be Alphanumeric only`),
    // branch_address: Yup.string(),
    // state_id: Yup.string().required('State is required.').nullable(),
    // city_id: Yup.string().required('City is required.').nullable(),
    // pincode: Yup.string()
    //   .required('Pincode is required.')
    //   .max(9, 'Pincode symbol should be at most 9 characters.')
    //   .min(5, 'Pincode symbol should be at most 5 characters.')
    //   .matches(/^[0-9\s]+$/, `Pincode name should be number`).nullable(),
    tally_godown: Yup.string()
      .trim()
      .min(3, 'Tally Godown minimum length is 3')
      .max(50, 'Tally Godown should be at most 50 characters.')
      .nullable(),
    voucher_type: Yup.string()
      .trim()
      .min(3, 'Voucher Type minimum length is 3')
      .max(50, 'Voucher Type should be at most 50 characters.')
      .nullable(),
    sales_ledger: Yup.string()
      .trim()
      .min(3, 'Sales Ledger minimum length is 3')
      .max(50, 'Sales Ledger should be at most 50 characters.')
      .nullable(),
        default_print_type: Yup.string().nullable(),
    expense_voucher_type: Yup.string()
      .trim()
      .max(45, "Expense Voucher Type should be at most 45 characters.")
      .nullable(),
    income_voucher_type: Yup.string()
      .trim()
      .max(45, "Income Voucher Type should be at most 45 characters.")
      .nullable(),
    cash_ledger: Yup.string()
      .trim()
      .max(45, "Cash Ledger should be at most 45 characters.")
      .nullable(),
    stock_voucher_type: Yup.string()
      .trim()
      .max(45, "Stock Voucher Type should be at most 45 characters.")
      .nullable(),
  })
}

export default branchSchema
